import React from "react";
import {t} from "../../../helpers/translator";
import Config from "../../../config/main";

export default function bookingInfoTemplate () {
    return <div className="ticket-results-view-p">
        {
            Config.enableLogoOnPopups && <div className="mini-logo-container"></div>
        }
        <h3>{t("Your BOOKING ID is")} {this.props.bookNum}</h3>
        <p>{t("Would you like to print your booking ticket?")}</p>
        <div className="buttons-view-w-t">
            <ul>
                <li>
                    <div className="separator-box-buttons-m">
                        <button className={this.props.isAdminLoggedIn ? "button-view-normal-m" : "button-view-normal-m trans-m"}
                                onClick={this.printBookingTicket()}>
                            {t("Yes")}
                        </button>
                    </div>
                </li>
                <li>
                    <div className="separator-box-buttons-m">
                        <button className="button-view-normal-m trans-m"
                                onClick={this.props.closePopup()}>
                            {t("Cancel")}
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>;
}